import React, { Component } from 'react';
import { LayoutWithNavbar } from 'layouts';
import { connect } from 'react-redux';
import {
  applicantAction,
} from 'shared/store/actions';
import { Stepper } from 'components';
import './Success.scss';
import { FormattedMessage } from 'react-intl';

class Success extends Component {
  componentDidMount() {
    /** redirect to homepage */
    setTimeout(() => {
      /** This is to save any change in data specially for new refCode */
      this.props.onSaveApplicant(false);

      this.props.history.push('/home');
    }, 3000);
  }

  render() {
    return (
      <div className="page-container page-container--success">
        <Stepper isStep1Completed isStep2Completed isStep3Active title="auth.registrationSuccess" />

        <article className="page-container__content page-container__content--small page-container__content--adjustMarginTop">
          <FormattedMessage id="redirecting" />
        </article>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refCode: state.applicantRootReducer.applicantReducer.imarkazRefCode,
  applicantId: state.applicantRootReducer.applicantReducer.applicantId,
});

const mapDispatchToProps = dispatch => ({
  onSaveApplicant: isGenerate => dispatch(applicantAction.updateApplicant(isGenerate)),
  onCreateApplicant: () => dispatch(applicantAction.createApplicant()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithNavbar(Success));
